import { render } from "./NosotrosPage.vue?vue&type=template&id=5dbc671c&scoped=true"
import script from "./NosotrosPage.vue?vue&type=script&lang=js"
export * from "./NosotrosPage.vue?vue&type=script&lang=js"

import "./NosotrosPage.vue?vue&type=style&index=0&id=5dbc671c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbc671c"]])

export default __exports__